/* =========================================================
   StaySpace — ajout au panier sans rechargement

   POURQUOI CE FICHIER
   Les formulaires d'achat sur mesure (vitrine, bloc d'achat de fin
   de page, barre collante mobile, fiche produit) sont des <form>
   Liquid natifs. Sans JavaScript, chacun provoque un POST complet
   puis un saut vers /cart : le visiteur perd sa position dans la
   page, et sur mobile il ne revient pas.

   Ce script les intercepte, poste sur /cart/add.js, puis demande à
   Shopify de re-rendre le tiroir et la pastille du panier. Dawn
   fournit déjà tout ça sur <cart-drawer> : on ne réimplémente rien,
   on branche.

   DÉGRADATION : s'il n'y a pas de <cart-drawer> dans la page, ou si
   fetch échoue, on ne fait rien et le navigateur envoie le
   formulaire normalement. Un panier qui recharge la page reste un
   panier qui marche ; un bouton mort, non.

   Cible : les formulaires portant l'attribut `data-ss-ajax`.
   ========================================================= */
(function () {
  'use strict';

  var enCours = false;

  document.addEventListener('submit', function (evenement) {
    var formulaire = evenement.target.closest('form[data-ss-ajax]');
    if (!formulaire) return;

    var tiroir = document.querySelector('cart-drawer');
    // Pas de tiroir (ou tiroir vide non initialisé) : on laisse faire
    // le navigateur plutôt que de bloquer la vente.
    if (!tiroir || typeof tiroir.renderContents !== 'function') return;
    if (enCours) {
      evenement.preventDefault();
      return;
    }

    evenement.preventDefault();
    enCours = true;

    var bouton = formulaire.querySelector('[type="submit"]');
    var libelle = bouton ? bouton.innerHTML : null;
    if (bouton) {
      bouton.setAttribute('aria-busy', 'true');
      bouton.disabled = true;
    }

    var donnees = new FormData(formulaire);
    // Les sections à re-rendre sont celles que Dawn déclare lui-même.
    var sections = tiroir.getSectionsToRender().map(function (section) {
      return section.id;
    });
    donnees.append('sections', sections.join(','));
    donnees.append('sections_url', window.location.pathname);

    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: donnees,
    })
      .then(function (reponse) {
        return reponse.json();
      })
      .then(function (etat) {
        if (etat.status) {
          // Shopify renvoie un statut d'erreur (rupture, quantité refusée).
          annoncer(formulaire, etat.description || etat.message);
          return;
        }
        tiroir.renderContents(etat); // re-rend ET ouvre le tiroir
      })
      .catch(function () {
        // Réseau coupé : on renvoie le formulaire en mode classique.
        formulaire.removeAttribute('data-ss-ajax');
        formulaire.submit();
      })
      .finally(function () {
        enCours = false;
        if (bouton) {
          bouton.removeAttribute('aria-busy');
          bouton.disabled = false;
          if (libelle !== null) bouton.innerHTML = libelle;
        }
      });
  });

  /* Message d'erreur lisible, annoncé aux lecteurs d'écran.
     Créé à la demande : inutile d'alourdir chaque formulaire d'un
     conteneur vide qui ne servira jamais. */
  function annoncer(formulaire, texte) {
    var zone = formulaire.querySelector('[data-ss-erreur]');
    if (!zone) {
      zone = document.createElement('p');
      zone.setAttribute('data-ss-erreur', '');
      zone.setAttribute('role', 'alert');
      zone.className = 'ss-erreur';
      formulaire.appendChild(zone);
    }
    zone.textContent = texte || 'Ajout impossible pour le moment.';
  }
})();
